import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Link from '@zenbusiness/zui/Link';
import Text from '@zenbusiness/zui/Text';

import { useProductLandingContext } from '../../contexts/useProductLanding';

const externalLink = (chunks, link) => (
  <Link
    clickstreamProps={{ elementName: 'footnote_link', elementPosition: 'footnotes' }}
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    textDecoration="none"
    color="text.secondary"
  >
    {chunks}
  </Link>
);

function FootnotesSection() {
  const { productConfig } = useProductLandingContext();
  const { footnotes } = productConfig;

  if (!footnotes) {
    return null;
  }

  return (
    <>
      <Divider />
      <div>
        {footnotes.map((footnote) => (
          <Text key={footnote.id} id={`footnote-${footnote.id}`} size="xs" gutterBottom>
            <sup>{footnote.id}</sup>
            {' '}
            <FormattedMessage
              id={footnote.text}
              values={{ externalLink: (chunks) => externalLink(chunks, footnote.link) }}
            />
          </Text>
        ))}
      </div>
    </>
  );
}

export default FootnotesSection;
